import { DataEntryPage } from "../components/data-entry-page/data-entry-page";

export const DataEntryPageRoute = () => {
  return <DataEntryPage />;
};
